<ion-app>
  <menu class="menu"></menu>
  <ion-router-outlet id="main-myMenu"></ion-router-outlet>
  <app-confirm-dialog></app-confirm-dialog>
</ion-app>
